<template>
  <div class="animated fadeIn">

    <b-card-body id="areaImprimir" >
      <b-row class="border-bottom mb-2">
        <b-col>
          <b-img  :src="img" left fluid style="max-height: 100px" alt="Responsive image"  class="rounded pb-0"></b-img>
          <h1 class="text-right text-uppercase">{{report_data.document_type}} #{{report_data.number}}</h1>
          <p class="text-right text-uppercase">Ingreso: {{report_data.created_at | moment }}</p>
          <a href="#" class="float-right text-black-50" @click="descargarPDF"><i class="fa fa-download"></i></a>
        </b-col>
      </b-row>
        <b-row class="mb-4">
          <b-col sm="6">
            <div class="text-uppercase"><strong>{{report_data.company_info.company_name}}</strong></div>
            <div class="text-uppercase">{{report_data.company_info.company_number}}</div>
            <div class="text-uppercase">{{report_data.company_info.address1}}</div>
            <div class="text-uppercase">{{report_data.company_info.address2}}</div>
            <div class="text-uppercase">Teléfono: {{report_data.company_info.phone}}</div>
          </b-col>
          <b-col sm="6">
            <div class="text-right text-uppercase"><strong>{{report_data.client_info.company_name}}</strong></div>
            <div class="text-right text-uppercase">{{report_data.client_info.company_number}}</div>
            <div class="text-right text-uppercase">{{report_data.client_info.address1}}</div>
            <div class="text-right text-uppercase">{{report_data.client_info.address2}}</div>
            <div class="text-right text-uppercase">Teléfono: {{report_data.client_info.phone}}</div>
          </b-col>
        </b-row>
        <h6 class="mb-3 font-weight-bold">DETALLE:</h6>
        <div class="table-responsive-sm">
          <table class="table  table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="left">#</th>
                <th class="align-middle">Código</th>
                <th class="align-middle">Producto</th>
                <th class="align-middle">Lote</th>
                <th class="align-middle">Empaque</th>
                <th class="text-center align-middle">Cantidad</th>
                <th class="text-right align-middle">Kg Netos</th>
              </tr>
            </thead>
            <tbody>
                <tr v-for="content in report_data.content_set">
                  <td class="left align-middle">{{content.number}}</td>
                  <td class="left align-middle">{{content.product_code}}</td>
                  <td class="left align-middle">{{content.product}}</td>
                  <td class="left align-middle">{{content.lot}}</td>
                  <td class="left align-middle">{{content.container}}</td>
                  <td class="text-center align-middle">{{content.quantity}}</td>
                  <td class="text-right align-middle">{{content.net_kilograms}} Kg</td>
                </tr>
            </tbody>
            <tfoot>
              <tr class="font-weight-bold">
                <td class="text-center"></td>
                <td class="left"></td>
                <td class="left"></td>
                <td class="left"></td>
                <td class="text-right">TOTALES</td>
                <td class="text-center">{{report_data.total_quantity}}</td>
                <td class="text-right">{{report_data.total_kilograms}} Kg</td>
              </tr>
            </tfoot>
          </table>
        </div>
       <b-row class="mt-3">
          <b-col lg="4" sm="5">
            <p class="font-weight-bold">Notas:</p>
            <p>Peso informado por productor: {{report_data.document_kilograms}}</p>
            <p>{{report_data.note}}</p>
          </b-col>
          <b-col lg="6" sm="6" class="ml-auto">

          </b-col>
        </b-row>
      </b-card-body>
  </div>
</template>

<script>

  import html2pdf from 'html2pdf.js'
  import moment from 'moment';
  import numeral from 'numeral';
  import locale from 'numeral/locales'

  numeral.locale('es');

    export default {
      name: "Report",
      props: ['report_data'],
      data () {
        return {
          img: '',
        }
      },
      filters: {
        moment: function (date) {
          return moment(date).format('DD-MM-YYYY MM:HH');
        },
        decimal (value) {
          return numeral(value).format('0,0.00');
        },
      },
      computed: {
        reportType () {
          // return this.report_data.document_type === 0 ? 'RECEPCIÓN ' : 'SALIDA '
          return true
        }
      },
      mounted() {
        this.img=localStorage.getItem('img');
      },
      methods: {
        moment: function () {
          return moment();
        },
        printDiv() {
          const prtHtml = document.getElementById('areaImprimir').innerHTML;
          let stylesHtml = '';
          for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            stylesHtml += node.outerHTML;
          }
          const WinPrint = window.open('', '', 'left=0,top=5,width=1280,height=2900,toolbar=0,scrollbars=0,status=0');
          WinPrint.document.write(`<!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);

          WinPrint.document.close();
          WinPrint.focus();
          WinPrint.print();
          WinPrint.close();

        },
        descargarPDF() {
          const element = document.getElementById('areaImprimir').innerHTML;
          const opt = {
            margin: 0.25,
            image: { type: 'jpeg', quality: 0.5 },
            filename: this.report_data.company_info.name+' G'+this.report_data.number+'.pdf',
            // html2canvas: { dpi: 192, letterRendering: true },
            jsPDF: {unit: 'in', format: 'letter', orientation: 'portrait'}
          };
          html2pdf(element, opt);
        }
      },
    };


</script>

<style scoped>

</style>
